import React, {FC} from 'react';

import classNames from 'classnames';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';
import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {Price} from 'components/price/price';

import s from '../baseProductItems.scss';

export type PropsType = {
    item: QuoteItemV2;
    nameComponent: React.ReactNode;
    supplyComponent: React.ReactNode;
    removeComponent?: React.ReactNode;
    children?: React.ReactNode;
};

/**
 * Base Product Contact lenses Vista Plus Item
 */
export const BaseLensesVistaProductItem: FC<PropsType> = ({
    children,
    item,
    nameComponent,
    removeComponent,
    supplyComponent,
}) => {
    return (
        <div className={s.topBar}>
            <div className={s.topBarContent}>
                <div className={s.imageBlock}>
                    <CloudinaryImage
                        alt={item.name}
                        className={s.image}
                        src={item.product.image}
                        width="100%"
                    />
                </div>
                <div className={s.shortDetails}>
                    {nameComponent}
                    <div className={classNames(s.simpleRow, s.vistaPrice)}>
                        <Price>{item.rowTotalDiscountedPriceWithoutTax}</Price> (starter pack of{' '}
                        {item.product.contactLensPerBox} lenses for&nbsp;10&nbsp;days)
                    </div>
                    {supplyComponent}
                    {children}
                </div>
            </div>
            {removeComponent}
        </div>
    );
};
